<template>
    <div>
        <h2>Confirm Your Email</h2>
        <p>Thank you for registering with Ultra Librarian.</p>
        <p>A confirmation email is on its way from support@ultralibrarian.com. You must confirm your email address before you can login. If you did not receive an email check your junk/spam folder.</p>
        <div>
            <router-link :to="backLink()"><i class="fa fa-arrow-left" aria-hidden="true"></i> Back to Search</router-link>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        name: 'RegisterConfirmation',
        computed: {
            ...mapState({
                searchBackLink: state => state.navigation.searchBackLink
            }),
        },
        methods: {
            backLink: function () {
                this.$router.isReady();
                if (this.searchBackLink != "")
                    return this.searchBackLink;
                else
                    return "/" + this.instance + "/search/";
            }
        }
    }
</script>

<style scoped>
</style>